import { useCallback } from 'react';
import CONTACT_US_MUTATION from './contactUs.mutation.graphql';
import { useMutation } from '@apollo/client';

const useContactUsSubmit = (user, origin, openSuccessModal) => {
  const [sendContactUs, { error }] = useMutation(CONTACT_US_MUTATION, { onCompleted: openSuccessModal });
  if (error) throw error;

  return useCallback(
    async (values) => {
      const contactUsDetails = {
        ...values,
        origin,
        userId: user.id,
      };

      await sendContactUs({ variables: { contactUsDetails } });
    },
    [origin, sendContactUs, user.id],
  );
};

export default useContactUsSubmit;
